export default __webpack_public_path__ + "static/media/grid.017.3271e355.jpeg";